module.exports = __webpack_public_path__ + "img/pc-help-4.b34ca6d5.jpg";